import { api } from "@/lib/axios";

interface CompanyProps {
  id: string;
  companyName: string;
  companyAddress: string;
  companyState: string;
  companyCity: string;
  companyZip: string;
  companyLogo: string;
  companyCountry: string;
  companyEmail: string;
}

export async function getCompany() {
  const { data } = await api.get<{ company: CompanyProps[] }>("/company");
  return data;
}
